export const START_LOADING = 'app/services/Users/START_LOADING';
export const CLEAR_ERRORS = 'app/services/Users/CLEAR_ERRORS';
export const GET_USERS_SUCCESS = 'app/services/Users/GET_USERS_SUCCESS';
export const GET_USERS_FAIL = 'app/services/Users/GET_USERS_FAIL';
export const ADD_USER_SUCCESS = 'app/services/Users/ADD_USER_SUCCESS';
export const ADD_USER_FAIL = 'app/services/Users/ADD_USER_FAIL';
export const UPDATE_USER_SUCCESS = 'app/services/Users/UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'app/services/Users/UPDATE_USER_FAIL';
export const DELETE_USER_SUCCESS = 'app/services/Users/DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'app/services/Users/DELETE_USER_FAIL';
export const SEND_ACTIVATION_SUCCESS = 'app/services/Users/SEND_ACTIVATION_SUCCESS';
export const SEND_ACTIVATION_FAIL = 'app/services/Users/SEND_ACTIVATION_FAIL';

export const startLoading = () => ({
  type: START_LOADING,
});

export const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

export const receivedGetUsersFail = (errors) => ({
  type: GET_USERS_FAIL,
  payload: { errors },
});

export const receivedGetUsersSuccess = (users) => ({
  type: GET_USERS_SUCCESS,
  payload: { users },
});

export const receivedAddUserFail = (errors) => ({
  type: ADD_USER_FAIL,
  payload: { errors },
});

export const receivedAddUserSuccess = (user) => ({
  type: ADD_USER_SUCCESS,
  payload: { user },
});

export const receivedDeleteUserFail = (errors) => ({
  type: DELETE_USER_FAIL,
  payload: { errors },
});

export const receivedDeleteUserSuccess = (userId) => ({
  type: DELETE_USER_SUCCESS,
  payload: { userId },
});

export const receivedUpdateUserFail = (errors) => ({
  type: UPDATE_USER_FAIL,
  payload: { errors },
});

export const receivedUpdateUserSuccess = (userProfile) => ({
  type: UPDATE_USER_SUCCESS,
  payload: { userProfile },
});

export const receivedSendActivationFail = (errors) => ({
  type: SEND_ACTIVATION_FAIL,
  payload: { errors },
});

export const receivedSendActivationSuccess = () => ({
  type: SEND_ACTIVATION_SUCCESS,
  payload: {},
});
